import apiClient from "./baseService";

export default {
	getAppVariables() {
		return apiClient.get("/getappvariables");
	},
}